import React, { useRef, useState } from 'react';
import { connect } from 'react-redux';

import { toggleModalWithTimer, toggleSpinner, updateMessages } from 'apps/auth/actions/appAction';
import { addExtras, setExtra } from 'apps/auth/actions/extraAction';
import { updatePageMessages } from 'apps/auth/actions/messageAction';
import { DiskButton } from 'apps/auth/components/common/DiskButton/DiskButton';
import BaseLayout from 'apps/auth/components/common/Layout/BaseLayout';
import { CommonPage } from 'apps/auth/components/common/Layout/CommonPage/CommonPage';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import { NavBar } from 'apps/auth/components/common/Layout/NavBar/NavBar';
import { Row } from 'apps/auth/components/common/Layout/Row';
import PopupNew from 'apps/auth/components/common/Popup/PopupNew';
import { Text } from 'apps/auth/components/common/Text/Text';
import BigCardForCardDetail from 'apps/auth/components/ga/cards/details/BigCardForCardDetail';
import CancelOrReissueCardPopup from 'apps/auth/components/ga/cards/details/CancelOrReissueCardPopup';
import ChangeLinkedAccPopup from 'apps/auth/components/ga/cards/details/linkedAccount/ChangeLinkedAccPopup';
import LinksForCardDetails from 'apps/auth/components/ga/cards/details/LinksForCardDetails';
import PinCreateScreen from 'apps/auth/components/ga/cards/order/plastic/PinCreateScreen';
import SmsConfirmation from 'apps/auth/components/ga/sms/SmsConfirmation';
import BasePage from 'apps/auth/components/utils/BasePage';
import { CANCEL_OR_REISSUE_CARD_POPUP, CHANGE_LINKED_ACC_POPUP } from 'apps/auth/constants/ComponentNames';
import { CHANGE_PIN_FORM_NAME } from 'apps/auth/constants/formName';
import { AUTH_GA_CARD, AUTH_GA_CARDS } from 'apps/auth/constants/UrlConstants';
import { apiFetchData } from 'apps/auth/helpers/api';
import { getCurrencyIcon, onIconRenderError } from 'apps/auth/helpers/utils';
import { requestOrderPlastic } from 'apps/auth/services/GaCardsService';

const CardDetailsPage = (props) => {
    const popupRef = useRef(null);
    const [showMode, setShowMode] = useState(false);
    const [showModal, setShowModal] = useState('');
    const [popups, setPopups] = useState('');

    const doRequest = (e, url, messageForModalWithTimer = '') => {
        e.preventDefault();
        setShowMode(false);
        popupRef?.current?.close();
        props.toggleSpinner(true);
        apiFetchData(url)
            .then((json) => {
                if (json) {
                    if (json.messageBodyMessages) {
                        props.updateMessages(json.messageBodyMessages);
                    }
                    if (json.messages) {
                        props.updatePageMessages(json.messages);
                    }
                    if (json.extra) {
                        props.setExtra(json.extra);
                    }
                }
                props.toggleSpinner(false).then(() => {
                    if (messageForModalWithTimer) {
                        props.toggleModalWithTimer(true, messageForModalWithTimer);
                    }
                });
            })
            .catch(() => {
                props.toggleSpinner(false);
            });
    };

    const onClickHandlerPinChange = () => {
        const helper = {
            fields: props.form[CHANGE_PIN_FORM_NAME]?.fields,
            toggleSpinner: props.toggleSpinner,
            setScreenSuccess: function () {
                props.toggleModalWithTimer(true, props.messagesCardPinChanged, () => {
                    setShowModal('useAtmForActivate');
                    props.toggleModalWithTimer(false);
                });
            },
            setScreen: setShowModal,
            addExtras: props.addExtras,
            url: `${AUTH_GA_CARD}${props.card.id}/create/pin`,
        };
        requestOrderPlastic(helper);
    };

    const getSecondaryText = (text1, text2) => {
        return (
            <>
                {text1}
                <br />
                <br />
                {text2}
            </>
        );
    };

    const getHeaderText = (emphasizedText, blackText) => {
        return (
            <>
                <Text variant="span" color="emphasized">
                    {emphasizedText}
                </Text>
                <br />
                {blackText}
            </>
        );
    };

    const getPopupComponent = () => {
        if (popups === CANCEL_OR_REISSUE_CARD_POPUP) {
            return <CancelOrReissueCardPopup popupRef={popupRef} />;
        }
        if (popups === CHANGE_LINKED_ACC_POPUP) {
            return <ChangeLinkedAccPopup doRequest={doRequest} popupRef={popupRef} getCurrencyIcon={getCurrencyIcon} onError={onIconRenderError} />;
        }
        return null;
    };

    if (showModal === 'smsConfirmation') {
        return (
            <CommonPage
                showChat={false}
                stateOptions={{ isGA: true }}
                backUrl="#"
                leftCloseIcon
                onClickIcon={(e) => {
                    e.preventDefault();
                    setShowModal('');
                }}
            >
                <SmsConfirmation setShowModal={() => setShowModal('changePin')} confirmURL={`/ga/sms/confirm.action?cardId=${props.card.id}`} />
            </CommonPage>
        );
    } else if (showModal === 'changePin') {
        return (
            <PinCreateScreen
                title={props.createYourPin}
                backUrl="#"
                onClickArrow={() => setShowModal('')}
                formName={CHANGE_PIN_FORM_NAME}
                onClickCreateLater={onClickHandlerPinChange}
            />
        );
    } else if (showModal === 'useAtmForActivate') {
        return (
            <BaseLayout showChat={false} stateOptions={{ isGA: true }}>
                <InfoPage
                    iconName="pos-thin"
                    iconColor="primary"
                    headerText={getHeaderText(props.activatePaymentsTitle1, props.activatePaymentsTitle2)}
                    secondaryText={getSecondaryText(props.activatePaymentsSubTitle1, props.activatePaymentsSubTitle2)}
                    primaryButtonCaption={props.gotItButton}
                    primaryButtonType="button"
                    primaryButtonOnClick={() => setShowModal('')}
                />
            </BaseLayout>
        );
    } else {
        return (
            <>
                <CommonPage showChat={false} stateOptions={{ isGA: true }}>
                    <Row indent="adaptive-32-48">
                        <BigCardForCardDetail
                            showMode={showMode}
                            setPopups={setPopups}
                            popupRef={popupRef}
                            getCurrencyIcon={getCurrencyIcon}
                            onError={onIconRenderError}
                        />
                    </Row>
                    <LinksForCardDetails setShowMode={setShowMode} showMode={showMode} doRequest={doRequest} setShowModal={setShowModal} />
                    {!props.isShowModalWithTimer && (
                        <NavBar align={'space-between'}>
                            <DiskButton iconName="arrow-back" to={AUTH_GA_CARDS} />
                            <DiskButton
                                iconName="dots"
                                type="tagA"
                                onClick={(e) => {
                                    e.preventDefault();
                                    popupRef?.current?.open(<CancelOrReissueCardPopup popupRef={popupRef} showOnePopup={true} />);
                                }}
                            />
                        </NavBar>
                    )}
                </CommonPage>
                <PopupNew ref={popupRef} getPopupComponent={getPopupComponent} />
            </>
        );
    }
};

const mapStateToProps = (state) => ({
    form: state.form,
    card: state.extra.card,
    isShowModalWithTimer: state.app.isShowModalWithTimer,
    createYourPin: state.messages.pageMessages.createYourPin,
    messagesCardPinChanged: state.messages.pageMessages.messagesCardPinChanged,
    gotItButton: state.messages.pageMessages.gotItButton,
    activatePaymentsTitle1: state.messages.pageMessages.activatePaymentsTitle1,
    activatePaymentsTitle2: state.messages.pageMessages.activatePaymentsTitle2,
    activatePaymentsSubTitle1: state.messages.pageMessages.activatePaymentsSubTitle1,
    activatePaymentsSubTitle2: state.messages.pageMessages.activatePaymentsSubTitle2,
});

export default connect(mapStateToProps, {
    updateMessages,
    toggleSpinner,
    updatePageMessages,
    setExtra,
    addExtras,
    toggleModalWithTimer,
})(BasePage(CardDetailsPage));
